module.exports = __webpack_public_path__ + "img/go-pc-basic-edition.f2fb1759.png";